var map = {
	"./en.json": [
		"88f0",
		"chunk-2d0df480"
	],
	"./es.json": [
		"388c",
		"chunk-2d0ba946"
	],
	"./fr.json": [
		"040f",
		"chunk-2d0a3c30"
	],
	"./it.json": [
		"587f",
		"chunk-2d0c91e8"
	],
	"./mx.json": [
		"2ad8",
		"chunk-2d0bd3f9"
	],
	"./pt.json": [
		"7324",
		"chunk-2d0d6714"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ef13";
module.exports = webpackAsyncContext;